import { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import GetParsedDate from "../../components/shared/GetParsedDate";
const baseURL = process.env.REACT_APP_API;

function ActiveUsers() {
  const [users, setUsers] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  useEffect(() => {
    console.log("Users");
    let isMounted = true;
    const controller = new AbortController();
    const getUsers = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "accounts/getloggedinusers/",
          {
            signal: controller.signal,
          },
        );
        isMounted && setUsers(response.data);
        console.log(response.data);
      } catch (err) {
        console.error(err);
        //navigate("/login", { state: { from: location }, replace: true });
      }
    };

    getUsers();
  }, []);

  /*useEffect(() => {
    fetch('/api/active-users/')
      .then(res => res.json())
      .then(data => setUsers(data.active_users))
      .catch(err => console.error('Error:', err));
  }, []);*/

  return (
    <div>
      <h4>משתמשים הנמצאים בתוך המערכת עכשיו</h4>
      <ul className="space-y-2">
        {users?.map((user) => (
          <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">
                  #
                </th>
                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">
                  Username
                </th>
                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">
                  Email
                </th>
                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">
                  Last Login
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {users?.map((user, index) => (
                <tr
                  key={user.id}
                  className={`hover:bg-gray-50 ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  }`}
                >
                  <td className="py-3 px-4 text-sm text-gray-800">
                    {index + 1}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-800">
                    {user.username}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-600">
                    {user.email}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-500">
                    <GetParsedDate strDate={user.last_login} withTime={true} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </ul>
    </div>
  );
}

export default ActiveUsers;
